export interface AssetDistributionDataModel<T> {
  id?: string | number;
  name?: string | number;
  groupId?: string | number;
  childGroupId?: string | number;
  value?: T[] | T;
  selected?: boolean;
}